import { render, staticRenderFns } from "./DownLoadList.vue?vue&type=template&id=3f37e2ae&scoped=true"
import script from "./DownLoadList.vue?vue&type=script&lang=js"
export * from "./DownLoadList.vue?vue&type=script&lang=js"
import style0 from "./DownLoadList.vue?vue&type=style&index=0&id=3f37e2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f37e2ae",
  null
  
)

export default component.exports